<template>
  <div class="raffles">
    <span id="r-send">
      <RafflesSendNotification
        v-if="showNotify"
        :sendData="sendData"
        @close="closeNotify"
      />
    </span>
    <va-card :title="$t('raffles.cards.title')">
      <template slot="actions">
        <va-button
          color="red"
          href="#r-send"
          icon="fa fa-send-o"
          @click="notify()"
        />
        <va-button
          icon="fa fa-plus"
          :to="{ name: 'raffles-add'}"
        />
      </template>
      <va-data-table
        :fields="fields"
        :data="raffles"
        :per-page="perPage"
        :totalPages="totalPages"
        :loading="loading"
        @page-selected="showMore"
        no-data-label="Sem Dados Cadastrados"
        api-mode
      >
        <template slot="actions" slot-scope="props">
          <va-popover :message="`${$t('tooltips.send')}`" placement="bottom">
            <va-button
              flat
              color="red"
              href="#r-send"
              icon="fa fa-send-o"
              @click="notify(props.rowData)"
            />
          </va-popover>
          <va-popover :message="`${$t('raffles.tooltips.raffle')}`" placement="bottom">
            <va-button
              flat
              color="gray"
              icon="fa fa-bitbucket"
              :to="{ name: 'raffle', params: { raffle: props.rowData.id } }"
            />
          </va-popover>
          <va-popover :message="`${$t('raffles.tooltips.tickets')}`" placement="bottom">
            <va-button
              flat
              color="gray"
              icon="fa fa-signal"
              :to="{ name: 'raffles-tickets', params: { raffle: props.rowData.id } }"
            />
          </va-popover>
          <va-popover :message="`${$t('raffles.tooltips.update')}`" placement="bottom">
            <va-button
              flat
              color="gray"
              icon="fa fa-pencil"
              :to="{ name: 'raffles-update', params: { raffleId: props.rowData.id } }"
            />
          </va-popover>
          <va-popover v-if="!props.rowData.realized" :message="`${$t('tooltips.delete')}`" placement="bottom">
            <va-button
              flat
              color="gray"
              icon="fa fa-trash"
              @click="showModal(props.rowData)"
            />
          </va-popover>
          <va-popover v-if="props.rowData.realized" :message="`${$t('raffles.tooltips.clean')}`" placement="bottom">
            <va-button
              flat
              color="gray"
              icon="fa fa-paint-brush"
              @click="showModalLimpar(props.rowData)"
            />
          </va-popover>
        </template>
      </va-data-table>
    </va-card>
    <va-modal
      v-model="modalDeletar"
      size="small"
      :title="$t('modals.titleDelete')"
      :message="$t('raffles.modals.message')"
      :okText="$t('modals.confirm') "
      :cancelText="$t('modals.cancel')"
      @ok="deleting"
    />
    <va-modal
      v-model="modalLimpar"
      size="small"
      :title="$t('raffles.modals.titleClean')"
      :message="$t('raffles.modals.messageClean')"
      :okText="$t('modals.confirm') "
      :cancelText="$t('modals.cancel')"
      @ok="cleaning"
    />
  </div>
</template>

<script>
import gql from 'graphql-tag'
import RafflesSendNotification from './RafflesSendNotification'

const perPage = 20
export default {
  name: 'raffles',
  components: {
    RafflesSendNotification,
  },
  methods: {
    notify (data = null) {
      this.sendData = data
      this.showAdd = false
      this.showNotify = true
    },
    closeNotify (v) {
      this.sendData = null
      this.showNotify = v
    },
    showModal (data) {
      this.modalDeletar = true
      this.deleteId = data
    },
    showModalLimpar (data) {
      this.modalLimpar = true
      this.cleanId = data
    },
    showMore (page) {
      this.loading = true
      this.page = page
      this.$apollo.queries.raffles.fetchMore({
        variables: {
          page: (page - 1) * this.perPage,
          perPage: this.perPage,
        },
        updateQuery: (_, { fetchMoreResult }) => {
          this.loading = false
          return fetchMoreResult
        },
      })
    },
    deletingUpload () {
      const self = this
      this.$axios.delete(
        '/api/upload',
        {
          data: {
            file: this.deleteId.image,
            path: 'raffles',
          },
        },
      ).then(resp => {
        self.deleting()
      })
    },
    deleting () {
      this.$apollo
        .mutate({
          mutation: gql`
            mutation MyMutation($id: Int!) {
              delete_raffle_by_pk(id: $id) {
                id
              }
            }
          `,
          variables: {
            id: this.deleteId.id,
          },
        })
        .then(data => {
          this.$apollo.queries.pages.refetch()
          this.showMore(this.page)
          this.showToast(
            this.$t('toasts.successDelete'),
            {
              icon: 'fa-check',
              position: 'top-right',
              duration: 1000,
              fullWidth: false,
            },
          )
        })
        .catch(_ => {
          this.showToast(
            this.$t('toasts.errorDelete'),
            {
              icon: 'fa-check',
              position: 'top-right',
              duration: 1000,
              fullWidth: false,
            },
          )
        })
    },
    cleaning () {
      this.$apollo
        .mutate({
          mutation: gql`
            mutation MyMutation($id: Int!) {
              up: update_raffle_winners(where: {raffle_id: {_eq: $id}}, _set: {active: false}) {
                affected_rows
                returning {
                  id: ticket_id
                }
              }
            }
          `,
          variables: {
            id: this.cleanId.id,
          },
        })
        .then(({ data }) => {
          this.$apollo
            .mutate({
              mutation: gql`
                mutation MyMutation($ticket: String!) {
                  update_raffle_ticket(where: {ticket_id: {_eq: $ticket}}, _set: {active: false}) {
                    affected_rows
                  }
                }
              `,
              variables: {
                ticket: data.up.returning[0].id,
              },
            }).then(data => {
              this.$apollo.queries.pages.refetch()
              this.showMore(this.page)
              this.showToast(
                this.$t('raffles.toasts.successClean'),
                {
                  icon: 'fa-check',
                  position: 'top-right',
                  duration: 1000,
                  fullWidth: false,
                },
              )
            }).catch(e => {
              console.log(e)
              this.showToast(
                this.$t('raffles.toasts.errorClean'),
                {
                  icon: 'fa-check',
                  position: 'top-right',
                  duration: 1000,
                  fullWidth: false,
                },
              )
            })
        })
        .catch(e => {
          console.log(e)
          this.showToast(
            this.$t('raffles.toasts.errorClean'),
            {
              icon: 'fa-check',
              position: 'top-right',
              duration: 1000,
              fullWidth: false,
            },
          )
        })
    },
  },
  data () {
    return {
      raffles: [],
      page: 1,
      perPage: perPage,
      pages: null,
      loading: false,
      modalDeletar: false,
      deleteId: 0,
      modalLimpar: false,
      cleanId: 0,
      showNotify: false,
      sendData: null,
    }
  },
  apollo: {
    raffles: {
      query: gql`
      query MyQuery($page: Int = 0, $perPage: Int = 2) {
        raffles: raffle(limit: $perPage, offset: $page, order_by: {id: desc}) {
          id
          name
          datetime
          authorization_number
          realized
          image
        }
      }
      `,
      variables: {
        perPage,
        page: 0,
      },
    },
    pages: gql`
    query MyQuery {
      pages: raffle_aggregate {
        aggregate {
          count
        }
      }
    }
    `,
  },
  computed: {
    totalPages () {
      return this.pages != null ? Math.ceil(this.pages.aggregate.count / this.perPage) : 0
    },
    fields () {
      return [{
        name: 'id',
        title: this.$t('tables.id'),
        width: '50px',
      }, {
        name: 'name',
        title: this.$t('raffles.headings.name'),
        width: '30%',
      }, {
        name: 'authorization_number',
        title: this.$t('raffles.headings.authorization_number'),
        width: '40%',
      }, {
        name: '__slot:actions',
        title: this.$t('tables.actions'),
        dataClass: 'text-center',
      }]
    },
  },
  mounted () {
    if (Object.keys(this.$apollo.queries).includes('raffles')) {
      this.$apollo.queries.pages.refetch()
      this.$apollo.queries.raffles.refetch()
    }
  },
}
</script>

<style lang="scss">
</style>
